import { useEffect } from "react";

export default function Privacy() {
  useEffect(() => { document.title = "Privacy — Toriano Sanzone"; window.scrollTo(0, 0); }, []);
  return (
    <div className="pt-[140px] pb-24 max-w-3xl mx-auto px-6" data-testid="privacy-page">
      <div className="text-eyebrow text-gold mb-4">Privacy Policy</div>
      <h1 className="font-display text-5xl mb-8">Privacy.</h1>
      <div className="space-y-5 text-bone/80 font-editorial leading-relaxed">
        <p>We respect your privacy. Information you share through forms on this site — name, email, phone, and inquiry details — is used solely to respond to your request and, when relevant, to send updates about services you've asked about.</p>
        <p>We do not sell, rent or share your information with third parties. Analytics tools may collect anonymized traffic data to help improve the site.</p>
        <p>Questions: <a href="mailto:info@torianosanzone.com" className="text-gold">info@torianosanzone.com</a> · 312.933.1528</p>
      </div>
    </div>
  );
}
